import { notification } from 'antd';
import React from 'react';
import { useNotifixationStore } from '../stores/notification';

const Notifications = (props: any) => {
  const [api, contextHolder] = notification.useNotification();
  const { notifications, removeNotification } = useNotifixationStore();

  notifications.forEach((notification) => {
    //const { message } = notification;
    api[notification.type]({
      message: notification.message,
      description: notification.description,
      placement: 'bottomLeft',
    });
    removeNotification(notification.id);
  });

  return <div>{contextHolder}</div>;
};

export default Notifications;
